import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';
import './styles/index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const getSentryEnvironment = () => {
  const rawEnv = import.meta.env.VITE_FIREBASE_PROJECT_ID || 'development';
  // Strip 'gobo-' prefix if present to standardize environment names (e.g. gobo-production -> production)
  return rawEnv.replace(/^gobo-/, '');
};

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: getSentryEnvironment(),
  release: __APP_VERSION__,
  integrations: [
    Sentry.replayIntegration(),
    Sentry.browserTracingIntegration(),
    Sentry.extraErrorDataIntegration(),
  ],
  // Session Replay
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  // Scrub data
  beforeSend: (event) => {
    // Filter out expected 401 errors (handled by auth flow)
    if (
      event.exception?.values?.some(
        (exc) =>
          exc.type === 'AxiosError' && exc.value?.includes('StatusCode=401')
      )
    ) {
      return null;
    }

    const uuidRegex =
      /[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/g;
    const replacementString = '[REDACTED_ID]';

    // Redact UUIDs from request URL and Referer
    if (event.request) {
      if (event.request.url) {
        event.request.url = event.request.url.replace(
          uuidRegex,
          replacementString
        );
      }
      if (event.request.headers && event.request.headers.Referer) {
        event.request.headers.Referer = event.request.headers.Referer.replace(
          uuidRegex,
          replacementString
        );
      }
    }

    // Redact UUIDs from breadcrumbs
    if (event.breadcrumbs) {
      event.breadcrumbs.forEach((breadcrumb) => {
        if (breadcrumb.data && breadcrumb.data.url) {
          breadcrumb.data.url = breadcrumb.data.url.replace(
            uuidRegex,
            replacementString
          );
        }
      });
    }

    return event;
  },
});

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
